function convertNumberToWords(num, useIndianFormat = true) {
  const a = [
    '', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine',
    'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen',
    'sixteen', 'seventeen', 'eighteen', 'nineteen'
  ];
  const b = [
    '', '', 'twenty', 'thirty', 'forty', 'fifty',
    'sixty', 'seventy', 'eighty', 'ninety'
  ];

  function inWords(n) {
    if (n === 0) return 'zero';
    if (n < 20) return a[n];
    if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? '-' + a[n % 10] : '');
    if (n < 1000) return a[Math.floor(n / 100)] + ' hundred' + (n % 100 ? ' and ' + inWords(n % 100) : '');
    return '';
  }

  if (num === 0) return 'zero';

  const units = useIndianFormat
    ? [
        { value: 10000000, name: 'crore' },
        { value: 100000, name: 'lakh' },
        { value: 1000, name: 'thousand' },
        { value: 100, name: 'hundred' }
      ]
    : [
        { value: 1000000000, name: 'billion' },
        { value: 1000000, name: 'million' },
        { value: 1000, name: 'thousand' },
        { value: 100, name: 'hundred' }
      ];

  let result = '';
  for (let i = 0; i < units.length; i++) {
    const { value, name } = units[i];
    if (num >= value) {
      const chunk = Math.floor(num / value);
      result += `${inWords(chunk)} ${name} `;
      num = num % value;
    }
  }

  if (num > 0) {
    if (result !== '') result += 'and ';
    result += inWords(num);
  }

  return result.trim();
}

export default convertNumberToWords;